import type { ReactNode } from 'react'

import { can, normalizeRole, type Action } from '@/features/auth/permissions'
import { useSession } from '@/features/auth/use-session'
import type { Role } from '@/shared/types/domain'

export interface RoleGateProps {
  /** Roles habilitados. Si no se pasa, se decide solo por `action`. */
  allow?: readonly Role[]
  /** Accion concreta de `permissions.ts`. Mas fino que el rol. */
  action?: Action
  /** Acota la accion a una empresa (membresia del `tech_member`). */
  companyId?: string | null
  children: ReactNode
  /** Que mostrar cuando no pasa. Por default, nada. */
  fallback?: ReactNode
}

/**
 * Segunda linea dentro de las pantallas.
 *
 * El guard de ruta protege la NAVEGACION; esto protege la UI: botones,
 * columnas, acciones de fila. No renderiza los hijos cuando no corresponde, asi
 * que el componente prohibido ni siquiera se monta.
 */
export function RoleGate({ allow, action, companyId, children, fallback = null }: RoleGateProps) {
  const { me } = useSession()

  if (!me) return <>{fallback}</>

  if (allow) {
    const role = normalizeRole(me.role)
    if (!role || !allow.includes(role)) return <>{fallback}</>
  }

  if (action && !can(me, action, { companyId })) return <>{fallback}</>

  return <>{children}</>
}
